import { createSlice } from "@reduxjs/toolkit";

const setLoading = (state, value) => {
  state.isLoading = value;
};

const setSuccessWithData = (state, data, key) => {
  state.isLoading = false;
  state[key] = data;
};

const setFailure = (state) => {
  state.isLoading = false;
};

const tenantsSlice = createSlice({
  name: "Tenants",
  initialState: {
    isLoading: false,

    tenantsList: [],
  },
  reducers: {
    // login
    getTenantsRequest: (state) => setLoading(state, true),
    getTenantsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantsList"),
    getTenantsFailure: (state) => setLoading(state, false),

    // get tenant Data with super admin tenant ID
    getTenantRequest: (state) => setLoading(state, true),
    getTenantSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantData"),
    getTenantFailure: (state) => setLoading(state, false),

    // get tenant Data with super admin tenant ID
    getTenantAdminsRequest: (state) => setLoading(state, true),
    getTenantAdminsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantAdminsData"),
    getTenantAdminsFailure: (state) => setLoading(state, false),


    getTenantManagersRequest: (state) => setLoading(state, true),
    getTenantManagersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantManagersData"),
    getTenantManagersFailure: (state) => setLoading(state, false),

    getTenantFarmersRequest: (state) => setLoading(state, true),
    getTenantFarmersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantFarmersData"),
    getTenantFarmersFailure: (state) => setLoading(state, false),

    getTenantSuppliersRequest: (state) => setLoading(state, true),
    getTenantSuppliersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantSuppliersData"),
    getTenantSuppliersFailure: (state) => setLoading(state, false),

    getTenantConsultantsRequest: (state) => setLoading(state, true),
    getTenantConsultantsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantConsultantsData"),
    getTenantConsultantsFailure: (state) => setLoading(state, false),

    getTenantCropsRequest: (state) => setLoading(state, true),
    getTenantCropsSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantCropsData"),
    getTenantCropsFailure: (state) => setLoading(state, false),

    getTenantSchedualersRequest: (state) => setLoading(state, true),
    getTenantSchedualersSuccess: (state, action) =>
      setSuccessWithData(state, action.payload, "tenantSchedualersData"),
    getTenantSchedualersFailure: (state) => setLoading(state, false),

  },
});

export const { getTenantsRequest, getTenantsSuccess, getTenantsFailure,
   getTenantRequest, getTenantSuccess, getTenantFailure,
   getTenantAdminsRequest, getTenantAdminsSuccess, getTenantAdminsFailure,
   getTenantManagersRequest, getTenantManagersSuccess, getTenantManagersFailure,
   getTenantFarmersRequest, getTenantFarmersSuccess, getTenantFarmersFailure,
   getTenantSuppliersRequest, getTenantSuppliersSuccess, getTenantSuppliersFailure,
   getTenantConsultantsRequest, getTenantConsultantsSuccess, getTenantConsultantsFailure,
   getTenantCropsRequest, getTenantCropsSuccess, getTenantCropsFailure,
   getTenantSchedualersRequest,
  getTenantSchedualersSuccess,
  getTenantSchedualersFailure,
   } =
  tenantsSlice.actions;

export const tenantsReducerSlice = tenantsSlice.reducer;
